import { Component } from '@angular/core';
import { AlertTypes, HeadingComponentConfig, HeadingType, TextComponentConfig } from '@rappider/rappider-components/utils';

@Component({
  selector: 'rappider-no-social-media-shared',
  templateUrl: './no-social-media-shared.component.html',
  styleUrls: ['./no-social-media-shared.component.scss']
})
export class NoSocialMediaSharedComponent {
  // Social media alert configurations
  isSocialMediaShared = false;
  SocialMediaAlertType = AlertTypes.Info;
  SocialMediaAlertTitle: HeadingComponentConfig = {
    content: 'Social Media Sharing Required',
    type: HeadingType.H2
  };
  SocialMediaAlertDescription: TextComponentConfig = {
    text: 'Please share your project on X or LinkedIn first to access server features. Share your achievement to enable all features!',
  };
}
